import React, { PureComponent, useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  ComposedChart,
} from "recharts";
import constants from "src/constants";

export default ({ data, dataKey }) => {
  const costs = [0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550];

  const [dim, setDim] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const lg = dim.width > 960;
  const md = dim.width < 960 && dim.width > 600;
  const sm = dim.width < 600;
  const graphHeight = lg
    ? dim.width / 3.9
    : md
    ? dim.width / 2.1
    : dim.width / 1.1;
  const barSize = lg ? 16 : md ? 10 : 4;

  let savings = [];

  useEffect(() => {
    function handleWindowResize() {
      const { innerWidth, innerHeight } = window;
      let winSize = { width: innerWidth, height: innerHeight };
      setDim(winSize);
    }
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  data.map((val, index) => {
    let temp = val["gimmicky"] - val["bluebonnet"]; // saving
    if (index > 0) {
      temp += savings[index - 1]["saving"]; // previous saving amount
    }

    savings.push({
      ...val,
      saving: temp,
    });
  });

  return (
    <ResponsiveContainer width="100%" height={graphHeight}>
      <ComposedChart
        // width={width}
        // height={height}
        barGap={0}
        data={savings}
        margin={{
          top: 50,
          right: sm ? 10 : 20,
          left: sm ? -18 : 10,
          bottom: 5,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          axisLine={{ stroke: "#99D7CF", strokeWidth: 0 }}
          dataKey={dataKey}
          tickLine={false}
          // tickMargin={10}
          tickCount={12}
          fontFamily="Futura PT Book"
          tick={<CustomizedXAxisTick sm={sm} md={md} lg={lg} />}
        />
        <YAxis
          tick={<CustomizedYAxisTick sm={sm} md={md} lg={lg} />}
          tickLine={false}
          unit={"$"}
          tickMargin={10}
          axisLine={{ stroke: "#B2B2B2", strokeWidth: 1 }}
          // domain={
          //   !sm
          //     ? [(dataMin) => Math.abs(dataMin) - 1, (dataMax) => dataMax + 100]
          //     : undefined
          // }
          //  ticks={!sm ? [200, 400, 600, 800, 1000] : undefined}
        />
        <Bar
          animationDuration={constants.graphAnimation}
          barSize={barSize}
          dataKey="gimmicky"
          fill="#EAEAEA"
        />
        <Bar
          animationDuration={constants.graphAnimation}
          barSize={barSize}
          dataKey="bluebonnet"
          fill="#009A88"
        />
        {!sm && (
          <Line
            animationDuration={constants.graphAnimation}
            label={<CustomizedLabel sm={sm} md={md} lg={lg} />}
            strokeDasharray={md ? "7 10 7" : "10 10 10"}
            dot={false}
            type="linear"
            dataKey="saving"
            unit="¢"
            name="Bluebonnet Rate"
            stroke="#09507F"
            strokeWidth={md ? 2 : 3}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

const CustomizedLabel = (props) => {
  const { x, y, stroke, value, sm, md, lg } = props;
  if (value && !sm) {
    return (
      <>
        <rect
          rx={8}
          ry={8}
          x={x - 15}
          y={y - 30}
          radius={8}
          width="45"
          height="23"
          fill="#E6EDF2"
        />
        <text
          fontSize={md ? 12 : 12}
          fontWeight={600}
          x={x}
          y={y}
          dy={-15}
          dx={5}
          fill={stroke}
          fontFamily="Futura PT Book"
          textAnchor="middle"
        >
          $ {value}
        </text>
      </>
    );
  } else {
    return null;
  }
};

const CustomizedXAxisTick = (props) => {
  const { x, y, stroke, payload, sm, md, lg } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        fontSize={sm ? 10 : 16}
        fontFamily="Futura PT Book"
        textAnchor="end"
        fill="#666"
      >
        {payload.value}
      </text>
    </g>
  );
};
const CustomizedYAxisTick = (props) => {
  const { x, y, stroke, payload, sm, md, lg } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        fontSize={sm ? 10 : 16}
        fontFamily="Futura PT Book"
        textAnchor="end"
        fill="#666"
      >
        $ {payload.value}
      </text>
    </g>
  );
};
